import { MenuItem, TextField, Checkbox, ListItemText } from '@material-ui/core';
import styled from 'styled-components';
import { colors } from 'shared/themes';

export const ITEM_HEIGHT = 56;
export const ITEM_PADDING_TOP = 8;
export const SELECT_MODAL_WIDTH = 350;

// useSelectStyles / useOutlinedInputStyles migrated to styled-components in chain-dispensary-select.tsx
// (Phase 0i, ECOMM-10311) — see `SelectWrapper` there.

// useCheckboxStyles / useListItemStyles migrated to styled-components (Phase 0j sub-PR 2,
// ECOMM-10311) -- both only override MUI's own stable global slot classes (MuiCheckbox-root,
// MuiListItemText-primary/secondary), and neither Checkbox nor ListItemText is portalled, so a
// plain styled(Component) wrapper reaches them directly.
//
// Note: MUI v4's default class-name generator special-cases a fixed list of "pseudo-class" rule
// keys (checked, disabled, error, focused, focusVisible, required, expanded, selected) for any
// component registered with a name starting in "Mui": those keys always get the literal global
// class `Mui-{key}` (e.g. `Mui-checked`), NOT `Mui{Component}-{key}` like other slots. Verified
// empirically via a rendered-DOM check, not just source inspection -- `checked` is on that list,
// which is why the selector below is `.Mui-checked`, not `.MuiCheckbox-checked`.
export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    color: #d0d3d9;
  }

  &.MuiCheckbox-root:hover {
    background-color: transparent;
  }

  &.MuiCheckbox-root.Mui-checked {
    color: ${colors.primaryBlue};
    outline-color: #d0d3d9;
  }

  &.MuiCheckbox-root.Mui-checked:hover {
    background-color: transparent;
  }
`;

export const StyledListItemText = styled(ListItemText)`
  .MuiListItemText-primary {
    color: ${colors.v2TextColor2};
    font-size: 13px;
    font-weight: bold;
    white-space: normal;
  }

  .MuiListItemText-secondary {
    color: ${colors.grey[45]};
    font-size: 12px;
    white-space: normal;
  }
`;

// useMenuItemStyles / useStateHeaderStyles / useSearchInputStyles migrated to styled-components
// (Phase 0k sub-PR 3, ECOMM-10311). None of MenuItem/TextField/OutlinedInput here are portalled,
// so plain styled(Component) wrappers reach their slots directly -- exported as StyledMenuItem
// and StyledSearchTextField below and used in place of the old classes={...} call sites.
//
// Note: MUI v4's default class-name generator special-cases a fixed list of "pseudo-class" rule
// keys (checked, disabled, error, focused, focusVisible, required, expanded, selected) for any
// component registered with a name starting in "Mui": those keys always get the literal global
// class `Mui-{key}` (e.g. `Mui-selected`), NOT `Mui{Component}-{key}` like other slots (e.g.
// `MuiMenuItem-gutters` is correctly component-prefixed since `gutters` isn't on that list).
// `selected` IS on that list -- the original `useMenuItemStyles.selected` rule already used the
// correct literal `&.Mui-selected` selector, carried forward as-is below.
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-gutters {
    padding-left: 0;
    padding-right: 8px;
  }

  &.MuiMenuItem-root {
    border-radius: 3px;
    margin: 8px 16px 8px 32px;
  }

  &.MuiMenuItem-root:hover {
    background-color: #f6f6f6;
  }

  &.MuiMenuItem-root.Mui-selected {
    background-color: ${colors.blue[90]};
  }
`;

export const StyledSearchTextField = styled(TextField)`
  &.MuiTextField-root {
    width: 100%;
    margin-top: 8px;
  }

  &.MuiTextField-root .MuiOutlinedInput-root {
    border-radius: 4px;
    font-size: 13px;
  }

  &.MuiTextField-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #b6b6b6;
  }

  &.MuiTextField-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #7fb1f4;
    border-width: 1px;
  }

  &.MuiTextField-root .MuiOutlinedInput-input {
    padding: 10px 12px;
  }
`;
